import { useCallback, useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router";

import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";

import api from "../../../../services/api";

const initialState = {
    id: null,
    operador_id: '',
    parada_id: '',
    observacao: ''
}

export default function AcabamentoLancamentoParadaV2() {
    const [data, setData] = useState([]);
    const [form, setForm] = useState({...initialState});
    const [operadores, setOperadores] = useState([]);
    const [paradas, setParadas] = useState([]);

    const [counter, setCounter] = useState(1);
    const [toInsert, setToInsert] = useState([]);

    const [startDate, setStartDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);
    const [seconds, setSeconds] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchParadas = useCallback(() => {
        api.get("acabamento/paradas").then(response => {
            setParadas(response.data);
        }).catch(error => {
            setParadas([]);
        });
    }, []);

    const fetchRolos = useCallback(() => {
        setIsLoading(true);
        api.get('acabamento/paradas-rolo', {
            params: {
                atual: true
            }
        }).then(response => {
            setIsLoading(false);
            setData(response.data);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }, []);

    const formatDate = (date) => {
        let dateF = String(date.getDate()).padStart(2, "0") + "/" + String(date.getMonth() + 1).padStart(2, "0") + "/" + date.getFullYear();
        let hourF = String(date.getHours()).padStart(2, "0") + ":" + String(date.getMinutes()).padStart(2, "0") + ":" + String(date.getSeconds()).padStart(2, "0");
        return `${dateF} ${hourF}`
    }

    const handleRestartCron = () => {
        setStartDate(null);
        setFinalDate(null);
        setSeconds(0);

        localStorage.removeItem('startdate');
        localStorage.removeItem('finaldate');
    }

    const handleStartCron = () => {
        if (startDate === null) {
            let _startDate = new Date();
            setStartDate(_startDate);
            localStorage.setItem('startdate', _startDate);
        } else {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Já existe um cronômetro em aberto." });
        }
    }

    const handleStopCron = () => {
        if (finalDate === null) {
            let date = new Date();
            setFinalDate(date);
            localStorage.setItem('finaldate', date);
        }
    }

    const handleSubmitItem = (newItem) => {
        setIsLoading(true);
        api.post('acabamento/paradas-rolo', newItem).then(response => {
            setIsLoading(false);
            showSuccess(response);

            let copy = [...toInsert];
            copy.push(newItem);

            setToInsert(copy);
            setCounter(counter => counter += 1);
            setStartDate(null);
            setFinalDate(null);
            setSeconds(0);

            localStorage.removeItem('startdate');
            localStorage.removeItem('finaldate');
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    const handleSaveItem = () => {
        if (form.parada_id === null || form.parada_id === "") {
            toast.current.show({ summary: "Aviso", severity: "warn", detail: "Selecione a parada para salvar o registro" });
            return;
        }

        let newItem = {};

        if(data.length === 1) {
            newItem.rolo_id = data[0].idartigo;
            newItem.nomerolo = data[0].nomerolo;
        } else {
            newItem.rolo_id = null;
            newItem.nomerolo = '';
        }

        newItem.key = counter;
        newItem.observacao = form.observacao;
        newItem.operador_id = form.operador_id;
        newItem.parada_id = form.parada_id;
        newItem.parada = paradas.find((element) => { return element.id === form.parada_id }).descricao;
        newItem.data_inicial = formatDate(startDate);
        newItem.data_final = formatDate(finalDate);

        let _seconds = (finalDate - startDate) / 1000;

        newItem.tempo = String(parseInt(_seconds / 3600)).padStart(2, "0") + ":" +
            String(parseInt(_seconds % 3600 / 60)).padStart(2, "0") + ":" +
            String(parseInt(_seconds % 60)).padStart(2, "0");

        handleSubmitItem(newItem);
    }

    useEffect(() => {
        if (startDate !== null) {
            let timeout = setTimeout(() => {
                if (finalDate === null) {
                    let now = new Date();
                    let diff = now - startDate;
                    setSeconds(diff / 1000);
                }
            }, [1000]);

            if (finalDate !== null) {
                setSeconds((finalDate - startDate) / 1000);
                clearTimeout(timeout);
            }
        }
    }, [startDate, finalDate, seconds]);

    useEffect(() => {
        fetchParadas();
        fetchRolos();

        let localStartDate = localStorage.getItem('startdate');
        if (localStartDate)
            setStartDate(new Date(localStartDate));

        let localFinalDate = localStorage.getItem('finaldate');
        if (localFinalDate)
            setFinalDate(new Date(localFinalDate));

        api.get('operadores').then((response) => {
            setOperadores(response.data);
        }).catch((error) => {
            setOperadores([]);
        });

    }, [fetchParadas, fetchRolos]);

    if (isLoading)
        return <Loading />

    return (
        <div>
            {/* <Menu /> */}
            <Toast ref={toast} />
            <div
                className="p-m-1 p-w-full"
            >
                <Button
                    className="p-button-success p-button-rounded p-m-1"
                    icon="pi pi-refresh"
                    onClick={fetchRolos}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                    title="Clique para atualizar os rolos caso tenha entrado um novo na Sanfo"
                />

                <Button
                    className="p-button-info p-button-rounded p-m-1"
                    icon="pi pi-arrow-left"
                    onClick={() => {
                        navigate('/acabamento/dashboard')
                    }}
                    style={{ position: 'absolute', left: 8, top: 8 }}
                    title="Clique para voltar a tela inicial"
                />

                <div className="p-d-flex p-flex-column p-jc-center p-ac-center">
                    <div>
                        <h1 className="p-text-center p-m-1">Rolo</h1>
                        <h1 className="p-text-center p-m-1">{data.length === 1 ? data[0].nomerolo : ''}</h1>
                        <h2 className="p-text-center p-m-1">{data.length === 1 ? data[0].cod_artigo : ''}</h2>
                    </div>

                    <span style={{ fontSize: 72, textAlign: 'center' }} >
                        {String(parseInt(seconds / 3600)).padStart(2, "0")}
                        :
                        {String(parseInt(seconds % 3600 / 60)).padStart(2, "0")}
                        :
                        {String(parseInt(seconds % 60)).padStart(2, "0")}
                    </span>

                    <div className="p-fluid p-m-4">
                        <div className="p-field">
                            <label style={{ fontSize: 24 }} htmlFor="operador_id">Operador: </label>
                            <Dropdown
                                filter
                                onChange={e => setForm({ ...form, operador_id: e.value })}
                                options={operadores}
                                optionLabel="nome"
                                optionValue="idoperador"
                                placeholder="-- Selecione um dos operadores --"
                                value={form.operador_id}
                            />
                        </div>

                        <div className="p-field">
                            <label style={{ fontSize: 24 }} htmlFor="parada_id">Motivo: </label>
                            <Dropdown
                                filter
                                onChange={e => setForm({ ...form, parada_id: e.value })}
                                options={paradas}
                                optionLabel="descf"
                                optionValue="id"
                                value={form.parada_id}
                            />
                        </div>

                        <div className="p-field">
                            <label style={{ fontSize: 24 }} htmlFor="observacao">Observação: </label>
                            <InputTextarea
                                onChange={e => setForm({ ...form, observacao: e.target.value })}
                                placeholder="..."
                                value={form.observacao}
                            />
                        </div>
                    </div>

                    {startDate === null && (
                        <Button
                            className="p-button-danger p-m-4"
                            iconPos="right"
                            icon="pi pi-stopwatch"
                            label="PARAR MÁQUINA"
                            onClick={() => handleStartCron()}
                            style={{ fontSize: 28 }}
                        />
                    )}

                    {startDate !== null && (
                        <>
                            {finalDate !== null && (
                                <>
                                    <Button
                                        className="p-button-info p-ml-4 p-mr-4"
                                        label="REINICIAR CRONÔMETRO"
                                        iconPos="right"
                                        icon="pi pi-refresh"
                                        onDoubleClick={handleRestartCron}
                                        style={{ fontSize: 28 }}
                                        title="Dê um duplo clique para reiniciar o cronômetro. Certifique-se de ter salvo os dados, se não eles serão perdidos. Apenas 1 clique NÃO FUNCIONARÁ"
                                    />

                                    <Button
                                        className="p-button-success p-mt-4 p-ml-4 p-mr-4"
                                        label="CLIQUE PARA SALVAR"
                                        iconPos="right"
                                        icon="pi pi-check"
                                        onClick={handleSaveItem}
                                        style={{ fontSize: 28 }}
                                        title="Clique para salvar o registro no banco de dados. Enquanto você não clicar nesse botão, os dados podem ser perdidos."
                                    />
                                </>
                            )}

                            {finalDate === null && (
                                <Button
                                    className="p-m-4 p-button-success"
                                    label="FINALIZAR PARADA"
                                    iconPos="right"
                                    icon="pi pi-stop-circle"
                                    onClick={handleStopCron}
                                    style={{ fontSize: 28 }}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}